import { IObstetricaLabResultsGroup } from "@/Common/Api/Labs/Dto/Responses/LabMessageGroupDTO";
import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { Locale } from "@/Common/Models/Localization/Locale";
import { ObstetricalFileField } from "@/Patient/Components/MedicalNote/ObstetricalFile/Control/ObstetricalFileField";
import { ObstetricalFileControlRenderer } from "@/Patient/Components/MedicalNote/ObstetricalFile/ControlRenderer/ObstetricalFileControlRenderer";
import { BaseObstetricalFileModel } from "@/Patient/Models/ObstetricalFile/BaseObstetricalFileModel";

interface BaseObstetricalFileSubSectionProps<TForm> {
    contributionId: string;
    readonly: boolean;
    previousObstetricalFile?: BaseObstetricalFileModel;
    handleFormUpdate: () => void;
    form: TForm;
    clickableTextId: string;
    onClickableTextChange: (id: string, context: string) => void;
    mutateModelState: (mutation: (state: TForm) => void, then?: () => void, shouldAutofillSignOffs?: boolean) => void;
    mutateModelStateWithFormUpdate: (mutation: (state: TForm) => void, then?: () => void, shouldAutofillSignOffs?: boolean) => void;
    fetchLabObservations?: () => Promise<IObstetricaLabResultsGroup[]>;
}

abstract class BaseObstetricalFileSubSection<TForm, TProps extends BaseObstetricalFileSubSectionProps<TForm>, TState> extends BaseReactComponent<TProps, TState> {
    protected controlRenderer: ObstetricalFileControlRenderer;
    protected get locale(): Locale { return Locale.en; }

    public componentWillMount(): void {
        this.setControlRenderer(this.props.readonly);
    }

    public componentWillReceiveProps(nextProps: BaseObstetricalFileSubSectionProps<TForm>): void {
        if (this.props.readonly !== nextProps.readonly)
            this.setControlRenderer(nextProps.readonly);
    }

    protected renderField(options: ObstetricalFileFieldOptions): JSX.Element {
        return (
            <ObstetricalFileField
                label={options.label}
                labelPrefix={options.labelPrefix}
                field={options.field}
                className={options.className}
                unit={options.unit}
                locale={this.locale}
                labelSuffix={options.labelSuffix}
                labelClassName={`${options.labelClassName} ${options.labelSuffix || options.labelPrefix ? "flex-col-gap-xs" : ""}`}
                inlineFlex={options.isInlineFlex}
                customLabel={options.customLabel}
                useLabelHtmlTagAsContainer={options.useLabelHtmlTagAsContainer}
            />
        );
    }

    private setControlRenderer(readonly: boolean): void {
        this.controlRenderer = new ObstetricalFileControlRenderer({
            readonly: readonly,
            onBlur: () => this.props.handleFormUpdate(),
            locale: this.locale
        });
    }
}

class ObstetricalFileFieldOptions {
    public label?: string;
    public field: React.ReactNode;
    public className?: string;
    public unit?: string;
    public labelPrefix?: React.ReactNode;
    public labelSuffix?: React.ReactNode;
    public labelClassName?: string;
    public isInlineFlex?: boolean = false;
    public customLabel?: React.ReactNode;
    public useLabelHtmlTagAsContainer?: boolean = true;
}

export { BaseObstetricalFileSubSection, BaseObstetricalFileSubSectionProps, ObstetricalFileFieldOptions };
